<p-chart #chart [width]="width" [height]="height" type="doughnut" [data]="chartData" [options]="chartOptions"></p-chart>
